<template>
	<div id="main-fn-head-body">
		<!-- float -left -->
		<div class="main-fn-head-body-left">
			<div @click="pickFile">
				<img src="./img/main-fn-head-before/icon tj wj01.svg" alt="" /><span>{{
					$t("addfile")
				}}</span>
			</div>
			<div @click="pickDir">
				<img src="./img/main-fn-head-before/icon tj wjj01.svg" alt="" /><span>{{
					$t("addfolders")
				}}</span>
			</div>
		</div>
		<!-- float -right -->
		<div v-show="!isEmpty" class="main-fn-head-body-right">
			<div @click="$hdapi.platform == 'WIN' || $app.isYsOver ? clear() : null">
				<img src="./img/main-fn-head-before/icon tj qklb01.svg" alt="" /><span>{{
					$t("clearlist")
				}}</span>
			</div>
		</div>
	</div>
</template>

<script>
import hdapi from "../common/hdapi";
export default {
	props: {
		ext: {type: String},
		isEmpty: {type: Boolean, default: false},
	},
	methods: {
		pickDir() {
			return hdapi.pickDir().then((dir) => {
				return (
					dir &&
					hdapi.readdir(dir).then((files) => {
						if (this.ext)
							files = files.filter((x) => hdapi.hasExt(x, this.ext)).map((x) => hdapi.join(dir, x));
						if (files.length > 0) this.$emit("push", files);
					})
				);
			});
		},
		pickFile() {
			return hdapi.pickFile(this.ext, true).then((files) => {
				if (files.length > 0) this.$emit("push", files);
			});
		},
		clear() {
			this.$emit("clear");
		},
	},
};
</script>

<style>
#main-fn-head-body {
	padding: 13rem 11rem 0rem 13rem;
	height: 46rem;
	width: 100%;
	box-sizing: border-box;
	/* border-bottom: 1rem solid #d9e0f6; */
}
#main-fn-head-body::after {
	content: "";
	height: 100%;
	/* display: inline-block;
		vertical-align: middle; */
	clear: both;
}

.main-fn-head-body-left {
	float: left;
}
.main-fn-head-body-right {
	/* display: none; */
	float: right;
}
.main-fn-head-body-left::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.main-fn-head-body-right::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}

.main-fn-head-body-left div {
	display: inline-block;
	text-align: center;
	width: 115rem;
	height: 33rem;
	background: #eff7fc;
	opacity: 1;
	border-radius: 8rem;
	vertical-align: middle;
	cursor: pointer;
	margin-right: 16rem;
}
.main-fn-head-body-left div::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.main-fn-head-body-right div {
	display: inline-block;
	text-align: center;
	vertical-align: middle;
	cursor: pointer;
	width: 115rem;
	height: 33rem;
	background: #eff7fc;
	opacity: 1;
	border-radius: 8rem;
}
.main-fn-head-body-left div::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.main-fn-head-body-right div::after {
	content: "";
	height: 100%;
	display: inline-block;
	vertical-align: middle;
}
.main-fn-head-body-left div img {
	width: 20rem;
	height: 20rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 6rem;
}
.main-fn-head-body-right div img {
	width: 20rem;
	height: 20rem;
	display: inline-block;
	vertical-align: middle;
	margin-right: 6rem;
}
.main-fn-head-body-left div span {
	/* width: 48rem;
	height: 17rem; */
	vertical-align: middle;
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 14rem; */
	color: #172f58;
	/* letter-spacing: 10rem; */
	opacity: 1;
}
.main-fn-head-body-right div span {
	vertical-align: middle;
	/* width: 48rem; */
	/* height: 17rem; */
	font-size: 12rem;
	font-family: MicrosoftYaHei;
	/* line-height: 14rem; */
	color: #5c7099;
	/* letter-spacing: 10rem; */
	opacity: 1;
}
.main-fn-head-body-left div:hover {
	background: #f7fcff;
}
.main-fn-head-body-right div:hover {
	background: #f7fcff;
}
.main-fn-head-body-left div:active {
	background: #e5f0f7;
}
.main-fn-head-body-right div:active {
	background: #e5f0f7;
}
@media screen and (max-height: 636px) {
	#main-fn-head-body * {
		font-size: 14.16rem !important;
	}
}
</style>
